import Repository from './Repository';

const resource = '/results';

export default {
    getStudentResults(payload) {return Repository.get(`${resource}/student`, payload);},
    getTeacherResults(payload) {return Repository.get(`${resource}/teacher`, payload);},
    getQuizResults(id) {return Repository.get(`${resource}/${id}`);},
    rateQuiz(payload, id) {return Repository.put(`${resource}/${id}`, payload);}
}